'use client';

import { forwardRef } from 'react';
import { cn } from '@/core/utils/cn';
import { Phone } from 'lucide-react';

interface PhoneInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  countryCode?: string;
}

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ className, label, error, countryCode = '+91', ...props }, ref) => {
    return (
      <div className="space-y-1.5">
        {label && <label className="block text-[12px] font-medium text-hms-textSub">{label}</label>}
        <div className="flex gap-2">
          <div className="flex items-center gap-1 px-3 h-9 bg-hms-bg border border-hms-border rounded-lg text-[13px] text-hms-textSub min-w-[70px]">
            <Phone className="w-3.5 h-3.5 text-hms-textDim" />
            {countryCode}
          </div>
          <input id="shared-phone-input-tel-1"
            ref={ref}
            type="tel"
            className={cn(
              'flex-1 h-9 px-3 text-[13px] text-hms-text bg-hms-bg border border-hms-border rounded-lg',
              'placeholder:text-hms-textDim',
              'focus:outline-none focus:ring-2 focus:ring-hms-gold/30 focus:border-hms-gold/50',
              'transition-colors duration-150',
              error && 'border-hms-red/50',
              className
            )}
            placeholder="9876543210"
            {...props}
          />
        </div>
        {error && <p className="text-[11px] text-hms-red">{error}</p>}
      </div>
    );
  }
);
PhoneInput.displayName = 'PhoneInput';
